import { Box, Button, Skeleton, Stack } from "@mui/material";
import { Player } from "../../../domain/model/User";
import { useTranslation } from "react-i18next";
import { LoadingView } from "../../component/LoadingView";
import { CustomImageView } from "../../component/CustomImageView";
import { APP_BG_IMAGE, STORAGE_KEYS } from "../../../data/constant/Constants";
import {
  COLOR_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_WHITE,
} from "../../../data/colors/Colors";
import useWindowDimensions from "../../../core/utils/UseWindowDimensions";
import { CustomButtonView } from "../../component/CustomButtonView";
import { CustomPopoverView } from "../../component/CustomPopoverView";
import { useState } from "react";
import InstagramLogo from "../../../assets/images/instagram_logo.png";
import { NewGameView } from "../newGame/NewGameView";
import { CustomTextView } from "../../component/CustomTextView";
import { GamesRounded, HistoryRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import SharedPreferences from "../../../core/utils/SharedPreferences";
import { ROUTE_ENDPOINTS } from "../../../data/constant/RouteConstants";
import { openLink } from "../../../core/utils/Utils";

export function PlayView({ player }: { player: Player | undefined }) {
  const { t } = useTranslation();

  const { width, height } = useWindowDimensions();
  const isMobile = width < 700 || height < 700;

  const [anchorElPosition, setAnchorElPosition] = useState<{
    top: number;
    left: number;
  } | null>(null);

  const [clickType, setClickType] = useState(1);
  const navigate = useNavigate();

  const [popoverContentHeight, setPopoverContentHeight] = useState("auto");

  return (
    <Stack>
      {!player ? (
        <LoadingView />
      ) : (
        <Stack
          width={"100%"}
          minHeight={"90vh"}
          p={isMobile ? 0 : 4}
          pt={isMobile ? 2 : 3}
          justifyContent={"space-between"}
          alignItems={"center"}
          spacing={2}
        >
          <Box />
          <Stack
            width={isMobile ? (width / height > 2 ? "50vw" : "100vw") : "75vw"}
            alignItems={"center"}
            spacing={1}
          >
            <CustomImageView
              width={"100%"}
              height={380}
              src={APP_BG_IMAGE}
              scale={"cover"}
            />
            <CustomButtonView
              text={t("start_new_game")}
              fontSize="body1"
              props={{ pt: 0.5, pb: 0.5, pr: 2, pl: 2 }}
              onClick={(e) => {
                setClickType(1);
                setAnchorElPosition({
                  top: e.clientY,
                  left: e.clientX,
                });
              }}
            />

            <Stack width={"100%"} alignItems={"center"} pt={2}>
              <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={1}
                sx={{ direction: "ltr" }}
              >
                <CustomImageView width={40} height={40} src={InstagramLogo} />
                <Button
                  onClick={() => openLink("https://instagram.com/", "_blank")}
                  sx={{ textTransform: "none", p: 0, borderRadius: 12 }}
                >
                  <CustomTextView
                    text={"@your_instagram_account"}
                    variant="h6"
                    fontWeight="bold"
                    textColor={COLOR_MAIN}
                  />
                </Button>
              </Stack>
            </Stack>
          </Stack>

          <Box />
        </Stack>
      )}

      <CustomPopoverView
        onClose={() => {
          setAnchorElPosition(null);
        }}
        anchorElPosition={anchorElPosition}
        width={
          isMobile
            ? width
            : isMobile
              ? width / height > 2
                ? "100%"
                : "30vw"
              : "28vw"
        }
        height={
          clickType == 2
            ? "100%"
            : isMobile
              ? width / height > 2
                ? "100%"
                : popoverContentHeight
              : popoverContentHeight
        }
        layout={
          <>
            {player && (
              <>
                {clickType == 1 && (
                  <>
                    <NewGameView
                      handleClose={() => setAnchorElPosition(null)}
                      handleHeightChanged={(h) => {
                        setPopoverContentHeight(h);
                      }}
                      player={player}
                      shouldChooseCategoryDirectly={true}
                    />
                  </>
                )}
              </>
            )}
          </>
        }
      />
    </Stack>
  );
}
